module.exports = __webpack_public_path__ + "static/media/handshake.6eba0f63.svg";